import styled from "styled-components";

const Title = styled.h1`
  color: #2ddf5c;
  text-align: center;
`;

export default Title;
